import "/__w/1/s/BotFramework-WebChat/packages/bundle/src/adaptiveCards/Attachment/AudioCardContent.module_built.css";
const classes = {"audio-card-attachment":"wumka_G_audio-card-attachment"}
export default classes

const _audio_card_attachment0 = classes["audio-card-attachment"]
export { _audio_card_attachment0 as "audio-card-attachment" }
